import { useEffect } from 'react';

const GoogleAuthHandler = () => {
  useEffect(() => {
    // Check if we have token and user data from Google OAuth callback
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const userData = urlParams.get('user');
    const error = urlParams.get('error');

    if (error) {
      // Handle OAuth error
      console.error('Google OAuth error:', error);
      alert('فشل في تسجيل الدخول بجوجل');
      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    if (token && userData) {
      try {
        // Parse user data
        const user = JSON.parse(decodeURIComponent(userData));
        
        // Store authentication data
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname);

        // Dispatch custom event to notify other components
        window.dispatchEvent(new Event('authStatusChanged'));

        // Reload page to update authentication state
        window.location.reload();
      } catch (err) {
        console.error('Error parsing user data:', err);
        alert('خطأ في معالجة بيانات المستخدم');
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleAuthHandler;
